// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UAYy","image":"Header_image__1a3QC","name":"Header_name__1xhzA","info":"Header_info__3ZANp","infoRow":"Header_infoRow__qdGMK"};